import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Result } from '@digibricks/domains';
import { PARTICIPATED_ASSIGNMENT_API } from '../data-sources';
import { ParticipatedAssignmentResponder, PARTICIPATED_ASSIGNMENT_RESPONDER_REPOSITORY } from '../../core';
import { USER_API } from '@module/user';
export var ParticipatedAssignmentRepository = /*#__PURE__*/function () {
  function ParticipatedAssignmentRepository(assignmentApi, userApi) {
    _classCallCheck(this, ParticipatedAssignmentRepository);

    this.assignmentApi = assignmentApi;
    this.userApi = userApi;
  }

  _createClass(ParticipatedAssignmentRepository, [{
    key: "getParticipatedAssignment",
    value: function () {
      var _getParticipatedAssignment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(queryParams) {
        var responseOrError, participatedAssignments, listUserIDs, userResponseOrError, userSummaries, participatedAssignmentsForResponderResponse, result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.assignmentApi.getParticipatedAssignment(queryParams);

              case 2:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", Result.fail(responseOrError.error));

              case 5:
                participatedAssignments = responseOrError.getValue(); // get user summary

                listUserIDs = participatedAssignments.map(function (participatedAssignment) {
                  return participatedAssignment.toJsonObject().createdBy;
                });
                _context.next = 9;
                return this.userApi.getUsers({
                  userIds: listUserIDs
                });

              case 9:
                userResponseOrError = _context.sent;

                if (!userResponseOrError.isFailure) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return", Result.fail(userResponseOrError.error));

              case 12:
                userSummaries = userResponseOrError.getValue(); // map user summary to participated assignment

                participatedAssignmentsForResponderResponse = participatedAssignments.map(function (participatedAssignment) {
                  return _objectSpread(_objectSpread({}, participatedAssignment.toJsonObject()), {}, {
                    assigner: userSummaries.find(function (assigner) {
                      return assigner.id.toString() === participatedAssignment.createdBy;
                    }).toJsonObject()
                  });
                });
                result = participatedAssignmentsForResponderResponse.map(function (participatedAssignment) {
                  return ParticipatedAssignmentResponder.fromJsonWithAssigner(participatedAssignment);
                });
                return _context.abrupt("return", Result.combineArray(result));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getParticipatedAssignment(_x) {
        return _getParticipatedAssignment.apply(this, arguments);
      }

      return getParticipatedAssignment;
    }()
  }]);

  return ParticipatedAssignmentRepository;
}();
export var participatedAssignmentRepositoryProvider = {
  provide: PARTICIPATED_ASSIGNMENT_RESPONDER_REPOSITORY,
  useFactory: function useFactory(assignmentApi, userApi) {
    return new ParticipatedAssignmentRepository(assignmentApi, userApi);
  },
  inject: [PARTICIPATED_ASSIGNMENT_API, USER_API]
};